export const productionHostname = 'repairer.partstrader.us.com';

export function isProduction(): boolean {
    const allowedHostnames = [
        'repairer.partstrader.us.com',
        'myorderly.partstrader.us.com',
    ];
    const hostname = new URL(window.location.href).hostname;
    return allowedHostnames.includes(hostname);
}
